/***
 * /////////////////////////////////////////////////////////////////
 * CONSTANTS (定数）
 * ----------------------------
 *
 * TYPEではないserviceContractsに関連するすべての定数について
 * 例を挙げると
 * API エンドポイント
 * /////////////////////////////////////////////////////////////////
 *
 */

export const TRANSFER_REQUEST_API_PATH = "/accounts/{UID}/service_contracts/{SUID}/transfer"

/***
 * TODO: 移管APIパスに移動「まだ作っていない状態ですから」
 * @type {string}
 */
export const TRANSFER_CONTRACT_REQUEST_API_PATH = "/accounts/{UID}/service_contracts/{SUID}/cancel";
